import { Box, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import Announcements from "../components/common/Announcements";
import { resetHeader, setAutocompleteVisibility, setHeaderText, setSelectedMenuItem } from "../redux/actions/action";

export default function AnnouncementsWrapper() {
    const dispatch = useDispatch()

    useEffect(() =>{
        dispatch(setHeaderText('Announcements'))
        dispatch(setSelectedMenuItem(4))
        return () => dispatch(resetHeader())
    },[dispatch])
    return (
        <Box
            px='1rem'
            w='95%'
            minH='90vh'
            mb='1rem'
            onClick={(e) => {
                e.stopPropagation()
                dispatch(setAutocompleteVisibility(false))
            }}
        >
            <Text
                fontSize={['20px', '25px', '30px', '40px']}
                d={['none', 'none', 'none', 'none', 'flex']}
                fontWeight='900'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                pt='2rem'
            >
                Announcements
            </Text>
            <Announcements dashboard = {false} />
        </Box>
    )
}